<script>
import { each } from "svelte/internal";

import Jouets from "../routes/jouets.svelte";


    export var panier;
    var hidden = true
    var depliant;

function toggle(){
    if(hidden){
        depliant.style.display = "flex"
        hidden = !hidden
    }else{
        depliant.style.display = "none"
        hidden = !hidden
    }
}

</script>


<div class="all">
    <div class="header">
        <div on:click={toggle} style="cursor:pointer;user-select: none;">📄</div>
        <div>Nombre d'articles : {panier.nbArticles}</div>
        <div>Bénévole : {panier.vendeur}</div>
        <div>Montant du panier : {panier.montantPanier}€</div>
        <div>Paiement : {panier.modePaiement }</div>
    </div>
    <div class="jouets" bind:this={depliant}>
        {#each panier.listeJouets as jouet}
        <div class="jouet">
            <div>Article : {jouet.name}</div>
            <div>Prix : {jouet.prix.toFixed(2)}€</div>    
            <div>No Inscrit : {jouet.codeVendeur}</div>
        </div>
        {/each}
    </div>
</div>


<style>
    .all{
        height: fit-content;
        width: 80vw;
        border-radius: 15px;
        background-color: rgb(87, 86, 86);
        margin: 15px;
        display: flex;
        flex-direction: column;
        font-family: 'Poppins', sans-serif;font-weight: 400;
    }

    .header{
        width: 100%;
        display: flex;
        height: fit-content;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        color: white;
        font-size: 1.2rem;
        padding: 7px;
        
    }

    .jouet{
        width: 80%;
        display: flex;
        height: fit-content;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        color: white;
        font-size: 1rem;
        padding: 5px;
    }

    .jouets{
        border-top: 2px solid gray;
        display: none;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: fit-content;
        transition: 0.5s all;
    }
</style>